interface Invoice {
  num: string;
  date: string;
  amount: string;
  items: string;
  paid: boolean;
}

const invoices: Invoice[] = [
  { num: 'BOO-2025-012', date: '1.3.2025', amount: '647 €', items: 'SEO, Google Ads, Social media', paid: true },
  { num: 'BOO-2025-008', date: '1.2.2025', amount: '647 €', items: 'SEO, Google Ads, Social media', paid: true },
  { num: 'BOO-2025-004', date: '1.1.2025', amount: '647 €', items: 'SEO, Google Ads, Social media', paid: true },
  { num: 'BOO-2024-048', date: '15.12.2024', amount: '1 490 €', items: 'Redesign e-shopu – záloha 100 %', paid: false },
];

export default function PortalFaktury() {
  const unpaid = invoices.filter((i) => !i.paid);
  const totalPaid = invoices.filter((i) => i.paid).length;

  return (
    <div className="p-6 flex flex-col gap-5 overflow-y-auto h-full">
      {/* Summary cards */}
      <div className="flex-shrink-0 grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="bg-amber-500/5 border border-amber-500/15 rounded-xl p-4 flex items-center gap-3">
          <div className="w-10 h-10 flex items-center justify-center bg-amber-500/10 border border-amber-500/20 rounded-lg flex-shrink-0">
            <i className="ri-error-warning-line text-amber-400 text-base" />
          </div>
          <div>
            <p className="text-amber-400 font-bold text-lg leading-none">{unpaid.length}</p>
            <p className="text-zinc-500 text-xs mt-0.5">Čaká na platbu</p>
          </div>
        </div>
        <div className="bg-emerald-500/5 border border-emerald-500/15 rounded-xl p-4 flex items-center gap-3">
          <div className="w-10 h-10 flex items-center justify-center bg-emerald-500/10 border border-emerald-500/20 rounded-lg flex-shrink-0">
            <i className="ri-checkbox-circle-line text-emerald-400 text-base" />
          </div>
          <div>
            <p className="text-emerald-400 font-bold text-lg leading-none">{totalPaid}</p>
            <p className="text-zinc-500 text-xs mt-0.5">Uhradených</p>
          </div>
        </div>
        <div className="bg-zinc-900 border border-zinc-800 rounded-xl p-4 flex items-center gap-3">
          <div className="w-10 h-10 flex items-center justify-center bg-zinc-800 border border-zinc-700 rounded-lg flex-shrink-0">
            <i className="ri-bill-line text-zinc-400 text-base" />
          </div>
          <div>
            <p className="text-white font-bold text-lg leading-none">{invoices.length}</p>
            <p className="text-zinc-500 text-xs mt-0.5">Celkovo faktúr</p>
          </div>
        </div>
      </div>

      {/* Invoice list */}
      <div className="bg-zinc-900 border border-zinc-800 rounded-2xl overflow-hidden">
        {/* Table header */}
        <div className="grid px-5 py-3 border-b border-zinc-800 text-zinc-500 text-xs font-semibold uppercase tracking-wide" style={{ gridTemplateColumns: '1.5fr 1fr 1fr 1.5fr 1fr auto' }}>
          <span>Číslo faktúry</span>
          <span>Dátum</span>
          <span>Suma</span>
          <span className="hidden sm:block">Položky</span>
          <span>Status</span>
          <span />
        </div>

        <div className="divide-y divide-zinc-800/50">
          {invoices.map((inv) => (
            <div key={inv.num} className="grid items-center px-5 py-4 hover:bg-zinc-800/20 transition-all" style={{ gridTemplateColumns: '1.5fr 1fr 1fr 1.5fr 1fr auto' }}>
              <span className="text-zinc-300 text-sm font-mono">{inv.num}</span>
              <span className="text-zinc-400 text-sm">{inv.date}</span>
              <span className="text-white text-sm font-bold">{inv.amount}</span>
              <span className="text-zinc-500 text-xs truncate hidden sm:block">{inv.items}</span>
              <span className={`text-xs font-semibold px-2.5 py-1 rounded-full w-fit ${inv.paid ? 'bg-emerald-500/10 border border-emerald-500/20 text-emerald-400' : 'bg-amber-500/10 border border-amber-500/20 text-amber-400'}`}>
                {inv.paid ? 'Uhradená' : 'Čaká na platbu'}
              </span>
              <button className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-zinc-700 text-zinc-500 hover:text-orange-400 cursor-pointer transition-all">
                <i className="ri-download-line text-sm" />
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
